export function canGoBack() {
  if (typeof window === 'undefined') {
    return false;
  }

  const state = window.history.state;
  if (state && typeof state.back === 'string' && state.back) {
    return true;
  }

  return window.history.length > 1;
}

export function safeBack(router, fallbackTo = '/home/index') {
  if (canGoBack()) {
    router.back();
    return;
  }

  router.replace(fallbackTo);
}
